import styled from 'styled-components/macro';
import TabButton from '~/components/Tab/TabButton';
import TabBar from '~/components/Tab/TabBar';
import Scrollbar from '~/components/Scrollbar';

export const ContainerArbitrationContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TabButtonFullWidth = styled(TabButton)`
  justify-content: space-between;
  padding: 22px;
`;

export const ArbitrationTabBar = styled(TabBar)`
  z-index: 12;
  padding-top: 4px;
`;

export const ModalScrollbar = styled(Scrollbar)`
  background-color: ${({ theme }) => theme.white};
`;
